import { clearVars, getWindowS, isNotUndefinedOrNull } from "./FunctionsCore";
const metaData = (props) => {
    const { adobeContentType, adobeDate, adobeKeywords, adobebu } = props;
    let count = 0;
    const trackEvents = () => {
        try {
            const windowS = getWindowS();
            if (isNotUndefinedOrNull(adobebu)) {
                windowS["eVar145"] = adobebu;
            }
            if (isNotUndefinedOrNull(adobeContentType)) {
                windowS["eVar146"] = adobeContentType;
            }
            if (isNotUndefinedOrNull(adobeKeywords)) {
                windowS["eVar147"] = adobeKeywords;
            }
            if (isNotUndefinedOrNull(adobeDate)) {
                windowS["eVar148"] = adobeDate;
            }
            if (isNotUndefinedOrNull(adobebu) || isNotUndefinedOrNull(adobeContentType) || isNotUndefinedOrNull(adobeKeywords) || isNotUndefinedOrNull(adobeDate)) {
                windowS.linkTrackVars = "eVar145,eVar146,eVar147,eVar148";
                windowS.tl(this, "o", "Adobe Page Events");
            }
            clearVars();
        }
        catch (er) {
            console.log("err in adobe event", er);
            if (count < 10) {
                // Checking window in every 5 sec if adove event is ready and not going more then 10 attempt to avoid max stack error.
                setTimeout(() => {
                    count = count + 1;
                    trackEvents();
                }, 5000);
            }
        }
    };
    trackEvents();
};
export { metaData };
